const SELECTOR = 'results-list .product-grid__item';
const scroller = document.querySelector('.page-wrapper');
const pending = new Set();

const observer = new IntersectionObserver(
  (entries) => {
    const intersecting = new Set(entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target));
    const cards = [...pending]
      .map((item) => ({ item, top: item.getBoundingClientRect().top }))
      .sort((a, b) => a.top - b.top);
    const rows = [];
    for (const { item, top } of cards) {
      let row = rows.find((candidate) => candidate.parent === item.parentElement && Math.abs(top - candidate.top) <= 4);
      if (!row) {
        row = { parent: item.parentElement, top, items: [] };
        rows.push(row);
      }
      row.items.push(item);
    }
    rows.filter((row) => row.items.some((item) => intersecting.has(item))).forEach((row, index) => {
      for (const item of row.items) {
        observer.unobserve(item);
        pending.delete(item);
        item.style.setProperty('--kame-cr-row', Math.min(index, 4));
        item.dataset.kameCr = 'shown';
      }
    });
  },
  { root: scroller && getComputedStyle(scroller).overflowY !== 'visible' ? scroller : null, threshold: 0.1 }
);

function scan() {
  const items = new Set(document.querySelectorAll(SELECTOR));
  for (const item of pending) {
    if (!items.has(item)) {
      observer.unobserve(item);
      pending.delete(item);
    }
  }
  for (const item of items) {
    if (item.dataset.kameCr === 'shown' || pending.has(item)) continue;
    item.dataset.kameCr = 'wait';
    pending.add(item);
    observer.observe(item);
  }
}

document.documentElement.classList.add('kame-cr-armed');
scan();
new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
